// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Yc5KzaW63rmqEuYyxCrC {
  position: relative;
  z-index: 301;
  overflow-x: hidden;
}

.JUOZ1h29Qw3seLR5fcKj {
  height: 95%;
  overflow-y: hidden;
  background: rgb(var(--primary-bg));
  z-index: 301;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  padding-bottom: 0 !important;
}
.olQRVCCHwgb3ljLQIewf {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  margin-bottom: 15px;
  z-index: 305;
}


.q6QKg4Y2zR12d4nvWzRZ {
  color: rgb(var(--accent-brand));
  font-size: 16.5px;
  font-weight: 540;
  letter-spacing: 0.43px;
  background: transparent;
  cursor: pointer;
  border: none;
  z-index: 305;
  padding: 4px;
  border-radius: 8px;
  transition: background 0.3s ease 0s;
}

.q6QKg4Y2zR12d4nvWzRZ > svg {
  cursor: pointer;
  > path {
    stroke: rgb(var(--accent-brand));
  }
}

.q6QKg4Y2zR12d4nvWzRZ:first-child {
  justify-content: flex-start;
}

.q6QKg4Y2zR12d4nvWzRZ:hover {
  background: transparent;
}

.q6QKg4Y2zR12d4nvWzRZ:active {
  background: rgba(var(--placeholder-tertiary), 0.2);
}

/* .modalTopButton:hover {
  background: rgba(var(--placeholder-tertiary), 0.2);
} */

.Y0dtE86OCHihZNcWYsOE {
  font-size: 17px;
  font-weight: 760;
  text-align: center;
  letter-spacing: 0.43px;
  line-height: 129.41%;
  margin: 0 auto;
}

.ToalnZMGsrcNOyLhicTO {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: scroll;
}

.NxxKVaWlfpHcnJbyKQTy {
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 40%;
  bottom: 0;
  border-radius: 600px;
  background: rgba(0, 122, 255, 0.25);
  filter: blur(110px);
  -webkit-backdrop-filter: blur(110px); 
}

.imPmorzUgPjyboaP2jro {
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 60%;
  bottom: 0;
  border-radius: 600px;
  background: rgba(16, 185, 129, 0.25);
  filter: blur(110px);
  -webkit-backdrop-filter: blur(110px); 
}

.eeTKJcCiEPUKXb6Y_VJo {
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 60%;
  bottom: 0;
  border-radius: 600px;
  background: rgba(234, 84, 111, 0.25);
  filter: blur(110px);
  -webkit-backdrop-filter: blur(110px); 
}`, "",{"version":3,"sources":["webpack://./src/pages/main/buy-modal/buy-modal.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;;AAGA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;;GAEG;;AAEH;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,mCAAmC;EACnC,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,oCAAoC;EACpC,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,oCAAoC;EACpC,mBAAmB;EACnB,oCAAoC;AACtC","sourcesContent":[".wrapper {\n  position: relative;\n  z-index: 301;\n  overflow-x: hidden;\n}\n\n.modal {\n  height: 95%;\n  overflow-y: hidden;\n  background: rgb(var(--primary-bg));\n  z-index: 301;\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 0 !important;\n}\n.modalTop {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 15px;\n  z-index: 305;\n}\n\n\n.modalTopButton {\n  color: rgb(var(--accent-brand));\n  font-size: 16.5px;\n  font-weight: 540;\n  letter-spacing: 0.43px;\n  background: transparent;\n  cursor: pointer;\n  border: none;\n  z-index: 305;\n  padding: 4px;\n  border-radius: 8px;\n  transition: background 0.3s ease 0s;\n}\n\n.modalTopButton > svg {\n  cursor: pointer;\n  > path {\n    stroke: rgb(var(--accent-brand));\n  }\n}\n\n.modalTopButton:first-child {\n  justify-content: flex-start;\n}\n\n.modalTopButton:hover {\n  background: transparent;\n}\n\n.modalTopButton:active {\n  background: rgba(var(--placeholder-tertiary), 0.2);\n}\n\n/* .modalTopButton:hover {\n  background: rgba(var(--placeholder-tertiary), 0.2);\n} */\n\n.modalTitle {\n  font-size: 17px;\n  font-weight: 760;\n  text-align: center;\n  letter-spacing: 0.43px;\n  line-height: 129.41%;\n  margin: 0 auto;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow-y: scroll;\n}\n\n.background {\n  position: absolute;\n  z-index: -1;\n  width: 100%;\n  height: 40%;\n  bottom: 0;\n  border-radius: 600px;\n  background: rgba(0, 122, 255, 0.25);\n  filter: blur(110px);\n  -webkit-backdrop-filter: blur(110px); \n}\n\n.backgroundSuccess {\n  position: absolute;\n  z-index: -1;\n  width: 100%;\n  height: 60%;\n  bottom: 0;\n  border-radius: 600px;\n  background: rgba(16, 185, 129, 0.25);\n  filter: blur(110px);\n  -webkit-backdrop-filter: blur(110px); \n}\n\n.backgroundError {\n  position: absolute;\n  z-index: -1;\n  width: 100%;\n  height: 60%;\n  bottom: 0;\n  border-radius: 600px;\n  background: rgba(234, 84, 111, 0.25);\n  filter: blur(110px);\n  -webkit-backdrop-filter: blur(110px); \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Yc5KzaW63rmqEuYyxCrC`,
	"modal": `JUOZ1h29Qw3seLR5fcKj`,
	"modalTop": `olQRVCCHwgb3ljLQIewf`,
	"modalTopButton": `q6QKg4Y2zR12d4nvWzRZ`,
	"modalTitle": `Y0dtE86OCHihZNcWYsOE`,
	"content": `ToalnZMGsrcNOyLhicTO`,
	"background": `NxxKVaWlfpHcnJbyKQTy`,
	"backgroundSuccess": `imPmorzUgPjyboaP2jro`,
	"backgroundError": `eeTKJcCiEPUKXb6Y_VJo`
};
export default ___CSS_LOADER_EXPORT___;
